<template>
  <div class="card">
    <div class="icon">
      <img
        :src="cardData.versionLogo"
        alt=""
      >
    </div>
    <div class="name">
      {{ cardData.versionName }}
    </div>
    <div class="desc">
      {{ cardData.versionDesc }}
    </div>
    <div class="price">
      <span class="price-num">{{ cardData.salePrice | moneyFix }}</span>
      <span class="price-unit">元/{{ cardData.servicePeriod }}</span>
    </div>
    <!-- <div
      v-if="cardData.price"
      class="price old"
    >
      <span class="price-old-num">{{ cardData.price|moneyFix }}</span>
      <span class="price-unit">元/{{ cardData.servicePeriod }}</span>
    </div> -->
    <Button
      type="primary"
      ghost
      class="buy-button"
      @click="goOrder(cardData.versionName)"
    >
      立即订购
    </Button>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: ()=>{
        return {
          versionName: '',
          versionDesc: '',
        };
      },
    },
  },
  data(){
    return {
      icon: {
        v1: 'data:img/png;base64,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',
      },
    };
  },
  methods: {
    goOrder(versionName){
      const {corpList,token} = this.$store.state.user.userInfo;
      if (token && (!corpList||!corpList.length)){
        // 弹出去认证弹框
        this.$root.$emit('show-auth-modal');
        return;
      }
      const {productCode} = this.$route.query;
      this.$router.push({
        path: '/standardProduct/order/index',
        query: {
          productCode,
          // corpCode,
          // corpName,
          versionName,
          // exchange: false,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
  .card {
    width: 310px;
    height: 380px;
    border-radius: 6px;
    box-shadow: 0 0 10px 1px #e7e7e7b3;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding-top: 48px;
    margin: 0 10px;
    .icon {
      width: 64px;
      height: 56px;
      margin-bottom: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      font-size: 18px;
      color: #333;
      font-weight: bold;
      margin-bottom: 17px;
    }
    .desc {
      height: 40px;
      width: 60%;
      overflow: hidden;
      font-size: 14px;
      line-height: 20px;
      color: #666;
      text-align: center;
    }
    .price {
      color: #666;
      margin: 20px 0 0 0;
      margin-bottom: 15px;
      &.old {
        font-size: 14px;
        color: #999;
        text-decoration: line-through;
        margin: 0;
      }
      &-num {
        font-size: 32px;
        color: #333;
      }
      &-unit {
        font-size: 14px;
      }
    }
    .buy-button{
      border-radius: 2px;
      font-size: 14px;
    }
  }
</style>    